import React, { createContext, useState } from "react";

// Create the context
export const ArtistContext = createContext(null);

// Create a provider component
export const ArtistProvider = ({ children, initialGroups = [] }) => {
  const [groups] = useState(initialGroups);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const [currentGroup, setCurrentGroup] = useState(initialGroups[0] || null);

  // Function to change the current group
  const changeGroup = (groupOrIndex) => {
    if (typeof groupOrIndex === "number") {
      const index = Math.max(0, Math.min(groups.length - 1, groupOrIndex));
      setCurrentGroupIndex(index);
      setCurrentGroup(groups[index]);
    } else if (typeof groupOrIndex === "string") {
      const index = groups.indexOf(groupOrIndex);
      if (index !== -1) {
        setCurrentGroupIndex(index);
        setCurrentGroup(groupOrIndex);
      }
    }
  };

  // Next and previous group functions
  const nextGroup = () => {
    const nextIndex = (currentGroupIndex + 1) % groups.length;
    changeGroup(nextIndex);
  };

  const prevGroup = () => {
    const prevIndex = (currentGroupIndex - 1 + groups.length) % groups.length;
    changeGroup(prevIndex);
  };

  // The value that will be provided to consumers of this context
  const value = {
    groups,
    currentGroup,
    currentGroupIndex,
    changeGroup,
    nextGroup,
    prevGroup,
  };

  return (
    <ArtistContext.Provider value={value}>{children}</ArtistContext.Provider>
  );
};
